/// LIST OF FEATURES ===================================================================

export const FEATURES = {
  IDINSPECT_VENDOR_FLOW: `inspect:vendorFlow`,
  IDINSPECT_VENDOR_FLOW_WITH_COI: `inspect:vendorFlow:coi`
}